import { tooltipTexts } from "../partials/table_config/tooltipTexts";
import { initTooltips } from "./initListeners";

export const thresholdNumberShelves = 3; // Порог максимального количества приборных полок

export function addBlock(containerId, counter, classPrefix) {
    const servObj = window.servObj || parent.servObj;
    const dspArrLength = document.querySelectorAll(".polka_pribornaya_dsp__item").length;
    const metallArrLength = document.querySelectorAll(".polka_pribornaya_metall__item").length;

    servObj.counterDsp = (dspArrLength > 0 && dspArrLength + 1) || 2; // Счетчик для блоков ДСП
    servObj.counterMetall = (metallArrLength > 0 && metallArrLength + 1) || 2; // Счетчик для блоков металла

    const container = document.getElementById(containerId);
    const template = container.querySelector(".params_block_item");

    // Глубоко клонируем блок
    const clone = template.cloneNode(true);

    // Удаляем id у клона, чтобы избежать дубликатов
    clone.removeAttribute("id");

    // Обновляем атрибуты name у всех input внутри клона
    clone.querySelectorAll("input").forEach((input) => {
        let oldName = input.getAttribute("name");
        if (oldName) {
            let newName = oldName.replace(/_(\d+)$/, `_${counter}`);
            input.setAttribute("name", newName);
        }
    });

    // Обновляем классы вида polka_params_ЧИСЛО
    clone.querySelectorAll(`[class*="${classPrefix}"]`).forEach((el) => {
        el.classList.forEach((cls) => {
            if (cls.startsWith(classPrefix) && /\d+$/.test(cls)) {
                const newClass = `${classPrefix}${counter}`;
                el.classList.replace(cls, newClass);
            }
        });
    });

    // Сброс состояния чекбоксов для polka_pribornaya_dsp
    if (containerId === "polka_pribornaya_dsp") {
        clone.querySelectorAll('input[type="checkbox"]').forEach((input) => {
            input.checked = false;
        });
        // Сброс радиокнопок: только первая отмечена, остальные нет
        clone.querySelectorAll('input[type="radio"]').forEach((input, idx) => {
            if (idx === 0) {
                input.checked = true;
            } else {
                input.checked = false;
            }
        });
    }

    // Вставляем клон в контейнер
    container.appendChild(clone);

    // Сразу чекаем добавленную полку
    clone.querySelectorAll(".stationery_shelf").forEach((input) => {
        input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
    });
}

export function resetShelfBlocks() {
    // Сброс ДСП
    const dspContainer = document.getElementById("polka_pribornaya_dsp");
    if (dspContainer) {
        // Оставляем только первый .params_block_item
        Array.from(dspContainer.querySelectorAll(".params_block_item")).forEach((item, idx) => {
            if (idx > 0) item.remove();
        });
    }
    // Сброс Металл
    const metallContainer = document.getElementById("polka_pribornaya_metall");
    if (metallContainer) {
        Array.from(metallContainer.querySelectorAll(".params_block_item")).forEach((item, idx) => {
            if (idx > 0) item.remove();
        });
    }
    // Сбросить счетчики
    servObj.counterDsp = 2;
    servObj.counterMetall = 2;

    // Выключить кнопки добавления
    document.querySelectorAll(".btn_add.add_dsp, .btn_add.add_metall").forEach((btn) => btn.classList.add("disable"));
}

// Назначаем обработчики событий для всех кнопок .btn_add
export const initAddShelfBlockListeners = () => {
    document.querySelectorAll(".btn_add").forEach((btn) => {
        btn.addEventListener("pointerdown", () => {
            const validCountDsp = servObj.counterDsp >= thresholdNumberShelves;
            const validCountMetall = servObj.counterMetall >= thresholdNumberShelves;

            if (btn.classList.contains("add_dsp")) {
                addBlock("polka_pribornaya_dsp", servObj.counterDsp, "polka_params_");
                servObj.counterDsp++;
                initTooltips(tooltipTexts);
                if (validCountDsp) btn.classList.add("disable"); // Дизейблим кнопку, как только количество полок достигает порога
            } else if (btn.classList.contains("add_metall")) {
                addBlock("polka_pribornaya_metall", servObj.counterMetall, "polka_params_");
                servObj.counterMetall++;
                initTooltips(tooltipTexts);
                if (validCountMetall) btn.classList.add("disable");
            }
        });
    });
};
